import { Slot } from 'app/routx-router'
import FlowPageLayout from 'app/src/layouts/FlowPageLayout'

export const Component: FC = () => {
  return (
    <FlowPageLayout>
      <Slot />
    </FlowPageLayout>
  )
}
export default Component
